import { useState } from 'react'

import ConversationRowTitle from '../ConversationRowTitle/index'
import styles from './ConversationRowGroup.module.scss'

const ConversationRowGroup = ({
  children,
  title,
  count,
  shouldShowCount,
  collapsedByDefault = false,
  bottomGroup,
  chatCat
}) => {
  const [collapsed, setCollapsed] = useState(collapsedByDefault)
  const collapsable = collapsedByDefault

  function handleTitleClick() {
    if (collapsable) {
      setCollapsed(!collapsed)
    }
  }

  return (
    <div className={[styles.group, bottomGroup ? styles.bottomGroup : ''].join(' ')}>
      <ConversationRowTitle
        title={title}
        count={count}
        shouldShowCount={shouldShowCount}
        onClick={handleTitleClick}
        collapsable={collapsable}
        collapsed={collapsed}
        chatCat={chatCat}
      />
      {!collapsed && children}
    </div>
  )
}

export default ConversationRowGroup
